import { Pipe, PipeTransform } from '@angular/core';
@Pipe({name: 'JuchuNoFilter'})
export class JuchuNoFilter implements PipeTransform {
  transform(value: string): string {
    if (value === undefined || value === null || value === '') {
      return '';
    } else {
      return value.length == 11 ? value.substr(0, 4) + '-' + value.substr(4, 6) + '-' + value.substr(10, 1) : value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/pipes/juchuno.pipe.ts